import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Heart, MessageCircle, User, Star } from 'lucide-react';

const tabs = [
  { path: '/', icon: Home, label: 'Feed' },
  { path: '/ek-jiv', icon: Star, label: 'Ek Jiv' },
  { path: '/matches', icon: Heart, label: 'Matches' },
  { path: '/messages', icon: MessageCircle, label: 'Messages' },
  { path: '/profile', icon: User, label: 'Profile' },
];

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="h-16 border-t border-border bg-background flex justify-around items-center shrink-0 relative z-[10000]" data-testid="bottom-nav">
      {tabs.map(({ path, icon: Icon, label }) => {
        const active = path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);
        return (
          <button
            key={path}
            onClick={() => navigate(path)}
            className={`flex flex-col items-center gap-0.5 transition-colors ${active ? 'text-primary' : 'text-muted-foreground'}`}
            data-testid={`bottom-nav-${label.toLowerCase()}`}
          >
            <Icon className="h-5 w-5" strokeWidth={active ? 2.5 : 1.5} />
            <span className="text-[10px] font-medium">{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
